// extracted by mini-css-extract-plugin
module.exports = {"Input":"ToggleInput_Input__xzsAT","Toggle":"ToggleInput_Toggle__228w0","ToggleContainer":"ToggleInput_ToggleContainer__gA0iB"};